import React, { useEffect, useMemo, useState } from "react";
import { graphql, PageProps } from "gatsby";

import { SEO } from "../components/common/seo";
import { MapPage } from "../components/Pages/Map";
import { VenueDataFragment } from "../components/Pages/Venue";
import { EventCardFragment } from "../components/common/EventCard";

interface MapDirectoryProps {
  venues: {
    edges: Array<{
      node: {
        frontmatter: Pick<
          VenueDataFragment,
          "image" | "name" | "status" | "description" | "tags"
        > & {
          whats_on: string[];
          location: string;
        };
        fields: {
          slug: string;
        };
      };
    }>;
  };
  events: {
    edges: Array<{
      node: {
        frontmatter: EventCardFragment;
        fields: {
          datetime: number;
        };
      };
    }>;
  };
}

const MapDirectoryPage: React.FC<PageProps<MapDirectoryProps>> = ({ data }) => {
  const [mount, setMount] = useState(false);

  const events = useMemo(() => {
    const datetime = new Date().getTime();

    return data.events.edges
      .filter(({ node }) => {
        if (node.fields.datetime < datetime && !node.frontmatter.recurring) {
          return false;
        }

        return true;
      })
      .map(({ node }) => ({
        ...node.frontmatter,
      }));
  }, [data.events]);

  useEffect(() => {
    setMount(true);
  }, []);

  return (
    <>
      <SEO title="Map" />

      {mount && (
        <MapPage
          items={data.venues.edges.map(({ node }) => ({
            ...node.frontmatter,
            location: JSON.parse(node.frontmatter.location),
            slug: node.fields.slug,
          }))}
          events={events}
        />
      )}
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default MapDirectoryPage;

export const query = graphql`
  query MapQuery {
    venues: allMarkdownRemark(
      sort: { order: ASC, fields: fields___slug }
      filter: { fields: { sourceName: { eq: "venues" } } }
    ) {
      edges {
        node {
          frontmatter {
            image {
              publicURL
            }
            name
            status
            description
            tags
            whats_on
            location
          }
          fields {
            slug
          }
        }
      }
    }
    events: allMarkdownRemark(
      sort: { order: ASC, fields: fields___datetime }
      filter: { fields: { sourceName: { eq: "events" } } }
    ) {
      edges {
        node {
          frontmatter {
            specific
            subtitle
            title
            earliest
            description
            image {
              publicURL
            }
            link
          }
          fields {
            datetime
          }
        }
      }
    }
  }
`;
